import axios from 'axios';
import axiosInstance from '../../../../helpers/axiosConfig';
import config from '../../../../config';

export class ApiService {

  static async getData() {
    const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL

    try {
      const urls = [
        `${baseUrl}Common/CellphonePrefixes`,
        `${baseUrl}Common/DocumentTypes`,
        `${baseUrl}Common/Professions`,
        `${baseUrl}Common/FormationPlaces`,
      ];


      const responses = await Promise.all(urls.map((url) => axios.get(url)))

      //console.log('Promises are: ', responses)

      return responses
    } catch (error) {
      // console.error('Error fetching data:', error)
      throw error
    }
  }




  static async postData(data) {

    try {
      const response = await axiosInstance.post('Member/Register',
        data,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      )

      //console.log('register information: ', response)
      return response
    } catch (error) {
      // console.error('Register catch Error:', error)
      throw error
    }

  }
}

